<template>
  <div id="app">
    <nav class="navbar navbar-default navbar-fixed-top">
      <div class="container-fluid">
        <div class="navbar-header">
          <router-link class="navbar-left" to="/"><img src="./assets/Logo.png" style="height:50px"/></router-link>
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          </div>
          <div class="collapse navbar-collapse" id="myNavbar">
          <ul class="nav navbar-nav">
            <router-link tag="li" to="/" active-class="active" exact><a>Home</a></router-link>
            <router-link tag="li" to="/verzetten"  active-class="active"><a>Verzetten</a></router-link>
            <router-link tag="li" to="/shop"  active-class="active"><a>Shop</a></router-link>
          </ul>
        </div>
      </div>
    </nav>
    <router-view></router-view>
    <div class="footer">
      <div class="row">
        <div class="col-sm-6 text-left">
          <strong>Tel</strong>
          +31 85 30 11 500
          <strong>Email</strong>
          info@fietsenmetvictor.nl


        </div>
        <div class="col-sm-4">
        </div>
        <div class="col-sm-4">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
/* Sticky footer styles
-------------------------------------------------- */
html {
  position: relative;
  min-height: 100%;
}
body {
  /* Margin bottom by footer height */
  padding-top: 65px; 
  margin-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  height: 60px;
  vertical-align: middle;
  background-color: #f5f5f5;
}



</style>



// WEBPACK FOOTER //
// App.vue?5e3c9d88